import { useRef, useState } from 'react'
import { useAppDispatch, useAppSelector } from '../../../../../store/hooks'
import { updateWorkspaceAvatarSaga } from '../../../../../store/workspace/workspaceSlice'
import { uploadAttachment } from '../../../../../lib/uploadAttachment'
import { toStaticImage } from '@/lib/toStaticImage'
import { TextNormBold, TextMidd } from '../../../../ui/Text'
import WorkspaceAvatar from '@/components/ui/WorkspaceAvatar/WorkspaceAvatar'
import DropdownWrapper from '@/components/ui/Dropdown/components/DropdownWrapper/DropdownWrapper'
import Dropdown from '@/components/ui/Dropdown/Dropdown'
import DropdownItem from '@/components/ui/Dropdown/components/DropdownItem/DropdownItem'
import css from './WorkspaceSettingsAvatar.module.css'

const WorkspaceSettingsAvatar = () => {
    const dispatch = useAppDispatch()
    const workspace = useAppSelector(state => state.workspace.workspace)
    const authUserId = useAppSelector(state => state.auth?.id)
    const inputRef = useRef<HTMLInputElement>(null)
    const [isDropdownOpen, setIsDropdownOpen] = useState(false)

    if (!workspace) return null

    const handleClick = () => {
        if (workspace.avatar) {
            setIsDropdownOpen(true)
        } else {
            inputRef.current?.click()
        }
    }

    const handleFileChange = async (e: React.ChangeEvent<HTMLInputElement>) => {
        const file = e.target.files?.[0]
        if (!file || !authUserId) return
        const staticFile = await toStaticImage(file)
        const { url } = await uploadAttachment({ file: staticFile, workspaceId: workspace.id, userId: authUserId })
        dispatch(updateWorkspaceAvatarSaga(url))
        e.target.value = ''
    }

    const handleReplace = () => {
        setIsDropdownOpen(false)
        inputRef.current?.click()
    }

    const handleDelete = () => {
        setIsDropdownOpen(false)
        dispatch(updateWorkspaceAvatarSaga(null))
    }

    return (
        <div className={css.container}>
            <DropdownWrapper>
                <div className={css.avatar} onClick={handleClick}>
                    <WorkspaceAvatar name={workspace.name} avatar={workspace.avatar} size="big" />
                </div>
                <Dropdown isOpen={isDropdownOpen} onClose={() => setIsDropdownOpen(false)}>
                    <DropdownItem title="Replace" onClick={handleReplace} />
                    <DropdownItem title="Delete" onClick={handleDelete} danger />
                </Dropdown>
            </DropdownWrapper>
            <div className={css.info}>
                <TextNormBold>Icon</TextNormBold>
                <TextMidd className={css.hint}>Recommended size 256×256px</TextMidd>
            </div>
            <input
                ref={inputRef}
                type="file"
                accept="image/*"
                className={css.input}
                onChange={handleFileChange}
            />
        </div>
    )
}

export default WorkspaceSettingsAvatar
